// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"c2492fef","462":"5ec84c31","595":"5479df9e","873":"8b97a518"}[chunkId] + ".chunk.css";
};